exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sales-information[data-v-92910f3a] {\n  padding: 30px;\n}\n.sales-information p[data-v-92910f3a],\n.sales-information ol[data-v-92910f3a],\n.sales-information ul[data-v-92910f3a] {\n  color: var(--v-primary-base);\n  font-weight: 500;\n}\n", ""]);

// exports
